<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.name" placeholder="输入班级名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
                <Col span="4">
                    <Input search v-model="formItem.realname" placeholder="输入老师姓名" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin-bottom: 20px;'>
                <Col span="6">
                    <Select v-model="formItem.school_id" placeholder="校区" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in schoolList" :value="item.school_id" :key="item.school_id">{{ item.school_name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
         <Modal v-model="addModel" width="520" title="修改">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <FormItem label="班级名称" prop='name'>
                        <Input v-model="formData.name" placeholder="请输入..."></Input>
                    </FormItem>
    
                    <FormItem label="上课时间" prop='study_week'>
                        <Select filterable v-model="formData.study_week" style='width:120px;' clearable>
                            <Option v-for="item in weekList" :value="item.id" :key="item.lesson_id">{{ item.id }}</Option>
                        </Select>
                        <span style="margin: 0 10px;"></span>
                        <TimePicker format="HH:mm" placeholder="选择时间" v-model="formData.study_time" style="width: 120px"></TimePicker>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle" @click="save('formData')">确定</Button>
            </div>
        </Modal>
        <Modal v-model="lessonModel" width="720" title="查看校区">
            <Table stripe border :columns="lessonColumns" :data="lessonData"></Table> 
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>关闭</Button>
            </div>      
        </Modal>
        <Modal v-model="lockModel" width="720" title="章节状态">
            <Table stripe border :columns="lockColumns" :data="lockData"></Table> 
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancelLock'>关闭</Button>
            </div>      
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        fetchLessonList,
        fetchLockList,
        fetchInfo,
        addModify
    } from '@/api/classList'
    import {
        fetchSchoolList,
    } from '@/api/common'

    import UploadImg from '../common/picture.vue'

    export default {
        name: 'user-components',
       
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    school_id: '', 
                    name: '', 
                    realname: '', 
                },
                lockModel:false,
                lessonModel:false,//查看校区弹出状态
                addModel:false,
                 weekList: [{
                        id: '周一'
                    },
                    {
                        id: '周二'
                    },
                    {
                        id: '周三'
                    },
                    {
                        id: '周四'
                    },
                    {
                        id: '周五'
                    },
                    {
                        id: '周六'
                    },
                    {
                        id: '周日'
                    },
                ],
                formData: {
                    class_name: '',
                    school_id: '',
                    class_id: '',
                },
                verificationRule: {
                    name: [{
                        required: true,
                        message: '不能为空'
                    }],
                    study_week: [{
                        required: true,
                        message: '不能为空'
                    }],
                }, //
                lessonColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '课程ID',
                        align: 'center',
                        key: 'lesson_id',

                    },
                    {
                        title: '课程名称',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            return h('div', [
                                
                                h('span', {
                                    style: {
                                        color:'#039CFD',
                                        cursor: 'pointer'
                                    },
                                    on: {
                                        click: () => {
                                            this.seeLock(params.row.class_lesson_id,params.row.lesson_id)
                                        }
                                    }
                                },params.row.name),
                            ])
                        }

                    },

                ],
                lockColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '章节名称',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'is_lock',
                        render: (h, params) => {
                            if(params.row.is_lock==1){
                                return h('div', '解锁')
                            }else{
                                return h('div', '未解锁')
                            }
                        }

                    },
                ],
                lockData:[],
                lessonData:[],
                schoolList:[],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '班级名称',
                        align: 'center',
                        key: 'name',

                    },
                    {
                        title: '班级老师',
                        align: 'center',
                        key: 'realname',
                    },
                    {
                        title: '校区',
                        align: 'center',
                        key: 'school_name',
                        
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 200,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        ghost: true
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.edit(params.row.class_id)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true

                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.seeLesson(params.row.class_id)
                                        }
                                    }
                                }, '查看课程'),
                            ])
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            
            getSchoolList(){
                fetchSchoolList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.schoolList=res.data;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
             edit(id) {
                fetchInfo({
                    class_id: id,
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.modelTitle = '修改';
                        this.formData = res.data;
    
                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 保存
            save(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();
                                this.addModel = false;
                            } else if (res.code == 14001) {
                                this.$Message.error(res.msg)
                                this.$store.dispatch('handleLogOut').then(res => {
                                    this.$store.commit('clearOpenedSubmenu')
                                    this.$router.push({
                                        name: 'login'
                                    })
                                })
                            } else {
                                this.$Message.error(res.msg)
                            }
                        })
    
                    }
                })
            },
            seeLock(class_lesson_id,lesson_id){
                fetchLockList({
                    class_lesson_id:class_lesson_id,
                    lesson_id:lesson_id,
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        if(res.data.length){
                            this.lockData = res.data;
                        }else{
                            this.lockData =[];
                        }
                        this.lockModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            seeLesson(id){
                fetchLessonList({
                    class_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        if(res.data.length){
                            this.lessonData = res.data;

                        }else{
                            this.lessonData =[];
                        }
                        this.lessonModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 取消关闭弹层
            cancel(){
                this.lessonModel=false;
            },
            cancelLock(){
                this.lockModel=false;

            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getSchoolList();
        }
    };
</script>
